import { requestGet } from "@/api/axios";

export const API_VERSION = "v1";

export const getCommonData = (params) =>
  requestGet(`/api/${API_VERSION}` + "/common-dic/index", params);

// export const HOME_VIDEO_URL = data.introduction_page + '/tronapp/tut.MP4'

// export const HOME_SERVICE_URL = data.kefu

// export const HOME_SERVICE_GROUP_URL = data.group

// export const APP_DOWNLOAD_URL = data.app_landing
export const THEME_COLOR = "#136DF9";

export const LANGUAGE_TYPE = [
  // { label: '简体中文', value: 'zh-cn' },

  { label: "English", value: "en", img: require("@/assets/lang/en.png") },
  { label: "한국인", value: "ko", img: require("@/assets/lang/kr.png") },
  { label: "繁體中文", value: "zh-hk", img: require("@/assets/lang/tw.png") },
  { label: "日本", value: "ja-jp", img: require("@/assets/lang/jp.png") },
  { label: "عربي", value: "ar", img: require("@/assets/lang/alq.png") },
  { label: "Français", value: "fr", img: require("@/assets/lang/fr.png") },
  { label: "Deutsch", value: "de", img: require("@/assets/lang/de.png") },
  { label: "español", value: "es", img: require("@/assets/lang/sp.png") },
  { label: "Italiano", value: "it", img: require("@/assets/lang/it.png") },
  // { label: 'हिन्दी', value: 'hi' },
  { label: "Indonesia", value: "id", img: require("@/assets/lang/id.png") },
  { label: "ไทย", value: "th", img: require("@/assets/lang/tl.png") },
  { label: "Türk", value: "tr", img: require("@/assets/lang/tur.png") },
  { label: "Tiếng Việt", value: "vi", img: require("@/assets/lang/vn.png") },

  { label: "Österreich", value: "adl", img: require("@/assets/lang/adl.png") },
  { label: "Ísland", value: "bd", img: require("@/assets/lang/bd.png") },
  { label: "България", value: "bjly", img: require("@/assets/lang/bjly.png") },
  { label: "Polska", value: "bl", img: require("@/assets/lang/bl.png") },
  { label: "Danmark", value: "dm", img: require("@/assets/lang/dm.png") },
  { label: "Suomi", value: "fl", img: require("@/assets/lang/fl.png") },
  {
    label: "Česká republika",
    value: "jk",
    img: require("@/assets/lang/jk.png"),
  },
  { label: "Hrvatska", value: "kldy", img: require("@/assets/lang/kldy.png") },
  { label: "România", value: "lmny", img: require("@/assets/lang/lmny.png") },
  { label: "Lëtzebuerg", value: "lsb", img: require("@/assets/lang/lsb.png") },
  { label: "Nederland", value: "nl", img: require("@/assets/lang/nl.png") },
  { label: "Norge", value: "nw", img: require("@/assets/lang/nw.png") },
  { label: "Portugal", value: "pt", img: require("@/assets/lang/pt.png") },
  { label: "Sverige", value: "rd", img: require("@/assets/lang/rd.png") },
  { label: "Schweiz", value: "rs", img: require("@/assets/lang/rs.png") },
  {
    label: "slovenija",
    value: "slwny",
    img: require("@/assets/lang/slwny.png"),
  },
  { label: "Србија", value: "sewy", img: require("@/assets/lang/sewy.png") },
  { label: "Україна", value: "wkl", img: require("@/assets/lang/wkl.png") },
  { label: "Ελλάδα", value: "xl", img: require("@/assets/lang/xl.png") },
  { label: "Ουγγαρία", value: "xyl", img: require("@/assets/lang/xyl.png") },
  // { label: '简体中文', value: 'zh-CN' },
];

export const BILL_TYPE = {
  1: "在线充值",
  2: "平台赠送",
  3: "推广收益",
  4: "机器消耗",
  6: "期权支出",
  7: "期权收入",
  8: "用户提现",
  10: "资金划转",
  11: "购买理财",
  12: "理财赎回",
  13: "游戏消费",
  14: "游戏收益",
  15: "资金划转出",
  17: "提现手续费",
  18: "冻结资金",
  19: "解冻资金",
  20: "闪兑支出",
  21: "闪兑收入",
  22: "闪兑手续费",
  23: "合约支出",
  24: "合约收入",
  25: "合约卖出手续费",
  26: "合约买入手续费",
  27: "在线充值",
  28: "系统减款",
  29: "任务奖励",
  30: "合约资金费率",
  31: "佣金分成",
  32: "法币充值",
  33: "法币提现",
  34: "在线充值",
  35: "足球收入",
  36: "足球支出",
  42: "VIP奖励",
  43: "平台出资",
  44: "平台出资收回",
  45: "投资大师奖励",
  46: "彩票支出",
  47: "彩票收入",
  48: "外汇",
  49: "在线充值",
  51: "币币买入支出",
  55: "币币买入支出退还",
  52: "币币买入获得",
  53: "币币卖出支出",
  56: "币币卖出支出退还",
  54: "币币卖出获得",
  57: "币币交易手续费",
  60: "现货买入手续费",
  61: "现货支出",
  62: "现货资金费率",
  63: "现货卖出手续费",
  64: "现货收入",
  65: "外汇合约支出",
  66: "外汇合约买入手续费",
  67: "外汇合约资金费率",
  68: "外汇合约卖出手续费",
  69: "外汇合约收入",
  70: "理财购买",
  71: "VIP理财日收益",
  72: "VIP理财隔夜利息",
  73: "VIP本金返还",
  74: "VIP彩金发放",
  75: "VIP彩金抵扣",
  76: "隔夜利息",
};

export const PARAMETER = {
  class: "index",
  action: "joinRoom",
  room: "",
  access_token: "",
};
export const LOGIN = {
  class: "index",
  action: "login",
  room: "",
  access_token: "",
};



// WEBPACK FOOTER //
// ./src/config/global_data.js